import React from "react"
import {
  iconSizeCss,
  statusIconColorCss,
  type StatusIconProps,
} from "@myvp/shared/src/styles/icon-utils"
import { css } from "@emotion/react"

const Alert = (
  props: Omit<StatusIconProps, "size"> & {
    size: StatusIconProps["size"] | "extra-large"
  }
) => {
  if (props.size === "small") {
    return (
      <svg
        className={props.className}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("critical", props.variant),
        ]}
      >
        <path
          d="M14 8.09967C14 11.2603 11.2975 14 7.99961 14C4.70169 14 2 11.2603 2 8.09967C2 4.93901 4.70168 2 7.99959 2C11.2975 2 14 4.93901 14 8.09967Z"
          fill="var(--shapeFillColor)"
          strokeWidth="2"
          stroke="var(--shapeStrokeColor)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 8.99968V3.99646H9V8.99969L7 8.99968Z"
          fill="var(--textColor)"
        />
        <path
          d="M9 9.97125V11.983H7.00004L7 9.97125H9Z"
          fill="var(--textColor)"
        />
      </svg>
    )
  }

  if (props.size === "large") {
    return (
      <svg
        className={props.className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("critical", props.variant),
        ]}
      >
        <circle
          cx="16"
          cy="16"
          r="13"
          stroke="var(--shapeStrokeColor)"
          strokeWidth="2"
          fill="var(--shapeFillColor)"
        />
        <path
          d="M16 8L16 19.3333M16 22.1667L16 25"
          stroke="var(--textColor)"
          strokeWidth="2"
        />
      </svg>
    )
  }

  if (props.size === "extra-large") {
    return (
      <svg
        className={props.className}
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          css`
            width: 56px;
            min-width: 56px;
            height: 56px;
            min-height: 56px;
          `,
          statusIconColorCss("critical", props.variant),
        ]}
      >
        <circle
          cx="28"
          cy="28"
          r="22.1875"
          fill="var(--shapeFillColor)"
          stroke="var(--shapeStrokeColor)"
          strokeWidth="3.625"
        />
        <path
          d="M28 14L28 32.5M28 37.5L28 42.5"
          stroke="var(--textColor)"
          strokeWidth="3"
        />
      </svg>
    )
  }

  // Default to props.size === "medium"
  return (
    <svg
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[
        iconSizeCss(props.size),
        statusIconColorCss("critical", props.variant),
      ]}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="var(--shapeStrokeColor)"
        strokeWidth="2"
        fill="var(--shapeFillColor)"
      />
      <path
        d="M12 7V13.6667M12 15.3333V17"
        stroke="var(--textColor)"
        strokeWidth="2"
      />
    </svg>
  )
}

export default Alert
